const translateEntityType = (value: string): string => ({
  invoice: 'فاتورة مبيعات',
  quote: 'عرض سعر',
  bill: 'فاتورة مشتريات',
  'purchase order': 'أمر شراء',
  task: 'مهمة',
  contact: 'جهة اتصال',
}[value.trim().toLowerCase()] || value);

export const residualTranslations: Record<string, string> = {
  'Something went wrong.': 'حدث خطأ ما.',
  'Close dialog': 'إغلاق مربع الحوار',
  'Type to search...': 'اكتب للبحث...',
  'No matching options found': 'لا توجد خيارات مطابقة',
  'READY': 'جاهز',
  'Prepare file for upload': 'تجهيز الملف للرفع',
  'Export a CSV bank statement from your online banking, then map and review its transaction lines before importing.': 'صدّر كشف حساب بنكي بصيغة CSV من الخدمات المصرفية الإلكترونية، ثم طابق الأعمدة وراجع المعاملات قبل الاستيراد.',
  'Alternatively, create your own statement file with our CSV template.': 'يمكنك بدلاً من ذلك إنشاء ملف كشف حساب باستخدام قالب CSV المتاح.',
  'Download Accountix CSV template (CSV, 56 B)': 'تنزيل قالب CSV ‏(56 بايت)',
  'Learn more about importing transactions': 'معرفة المزيد عن استيراد المعاملات',
  'Most recent transaction': 'أحدث معاملة',
  'Spent': 'المدفوع',
  'Spend': 'دفع',
  'Received': 'المقبوض',
  'Receive': 'قبض',
  'Example CSV Format': 'مثال لتنسيق CSV',
  'Download Template': 'تنزيل القالب',
  'File to upload': 'الملف المطلوب رفعه',
  'Drag and drop file or select manually': 'اسحب الملف وأفلته أو اختره يدويًا',
  'Select file': 'اختيار ملف',
  'For local PostgreSQL mode, export your statement as CSV.': 'في وضع PostgreSQL المحلي، صدّر كشف الحساب بصيغة CSV.',
  'Import settings': 'إعدادات الاستيراد',
  'Map the columns from your file to the system fields.': 'طابق أعمدة الملف مع حقول النظام.',
  'System Field': 'حقل النظام',
  'File Column': 'عمود الملف',
  'Example Value': 'قيمة مثال',
  'Other Column': 'عمود آخر',
  'Payee': 'المستفيد',
  'Check Number': 'رقم الشيك',
  'Review transactions': 'مراجعة المعاملات',
  'Statement line': 'بند كشف الحساب',
  'Ready to import': 'جاهز للاستيراد',
  'Complete Import': 'إكمال الاستيراد',
  'Statement of Account': 'كشف الحساب',
  'Loading statement...': 'جاري تحميل كشف الحساب...',
  'No transactions found for this period.': 'لا توجد معاملات خلال هذه الفترة.',
  'Start Date': 'تاريخ البداية',
  'End Date': 'تاريخ النهاية',
  'Debit': 'مدين',
  'Credit': 'دائن',
  'Balance': 'الرصيد',
  'Item Details': 'تفاصيل الصنف',
  'SKU (Stock Keeping Unit)': 'رمز الصنف (SKU)',
  'Stock Settings': 'إعدادات المخزون',
  'Track Inventory': 'تتبع المخزون',
  'POS Enabled': 'مفعّل في نقطة البيع',
  'Hide from POS': 'إخفاء من نقطة البيع',
  'LOT:': 'الدفعة:',
  'EXP:': 'الصلاحية:',
  'No stock records found': 'لا توجد سجلات مخزون',
  'No history records found.': 'لا توجد سجلات محفوظات.',
  'Product Formulations': 'تركيبات المنتج',
  'Product Variations': 'متغيرات المنتج',
  'Edit Status / Content': 'تعديل الحالة أو المحتوى',
  'Edit Status': 'تعديل الحالة',
  'View Delivery': 'عرض التسليم',
  '+ Add reminder': '+ إضافة تذكير',
  'Get link': 'الحصول على الرابط',
  'Scan QR': 'مسح رمز QR',
  'Scan QR Code': 'مسح رمز QR',
  'Copy to': 'نسخ إلى',
  'Total (Excl. Disc)': 'الإجمالي قبل الخصم',
  'Due': 'المستحق',
  'Discard Changes': 'تجاهل التغييرات',
  'selected': 'محدد',
  '[remove]': '[إزالة]',
  'Analysis failed': 'فشل التحليل',
  'Could not switch organization': 'تعذر تبديل المؤسسة',
  'Failed to load employees': 'تعذر تحميل الموظفين',
  'Failed to approve submission': 'تعذر اعتماد الطلب',
  'Failed to reject submission': 'تعذر رفض الطلب',
  'Failed to load POS sales': 'تعذر تحميل مبيعات نقطة البيع',
  'Failed to delete parked invoice': 'تعذر حذف الفاتورة المعلقة',
  'Failed to load payruns': 'تعذر تحميل تشغيلات الرواتب',
  'Total Expense': 'إجمالي المصروفات',
  'Revenue (Invoiced)': 'الإيرادات (المفوتر)',
  'Expenses (Accrued)': 'المصروفات (المستحقة)',
  'Cash In (Receipts)': 'التدفقات الداخلة (المقبوضات)',
  'Cash Out (Payments)': 'التدفقات الخارجة (المدفوعات)',
  'Net Cash Flow': 'صافي التدفق النقدي',
  'Earned (Invoices)': 'المكتسب (الفواتير)',
  'Spent (Bills)': 'المنفق (فواتير المشتريات)',
  'Custom Item': 'صنف مخصص',
  '/ unit': '/ وحدة',
  'Select location...': 'اختر موقعًا...',
  'Destination': 'الوجهة',
  'e.g. Business Checking': 'مثال: حساب جاري للأعمال',
  'e.g. Chase Bank': 'مثال: اسم البنك',
  'Last 4 digits': 'آخر 4 أرقام',
  'e.g. Row A, Shelf 1': 'مثال: الصف أ، الرف 1',
  'e.g. Sales Journal': 'مثال: يومية المبيعات',
  'e.g. Computer Equipment': 'مثال: معدات الحاسب',
  'e.g. Kilogram, Box, Litre': 'مثال: كيلوجرام، صندوق، لتر',
  'e.g. Size, Color, Material': 'مثال: المقاس، اللون، الخامة',
  'e.g. Urgent, Intercompany': 'مثال: عاجل، بين الشركات',
  'Add tag and press Enter...': 'أضف وسمًا واضغط Enter...',
  'Welcome! This guide will walk you through the basic features of our platform.': 'مرحبًا! سيساعدك هذا الدليل على التعرف إلى الميزات الأساسية للمنصة.',
  '1. Dashboard Overview': '1. نظرة عامة على لوحة القيادة',
  'Your dashboard provides a high-level view of your business metrics.': 'تعرض لوحة القيادة ملخصًا عامًا لمؤشرات أعمالك.',
  '2. Navigation': '2. التنقل',
  'Use the sidebar to access different modules like Invoices, POS, Inventory, and settings.': 'استخدم الشريط الجانبي للوصول إلى الوحدات المختلفة مثل الفواتير ونقطة البيع والمخزون والإعدادات.',
  'A quick 5-minute video walkthrough covering all core features.': 'جولة فيديو سريعة مدتها خمس دقائق تغطي جميع الميزات الأساسية.',
  'QUOTATION': 'عرض سعر',
  'DATE': 'التاريخ',
  'EXPIRES': 'تاريخ الانتهاء',
  'REFERENCE': 'المرجع',
  'BILL TO': 'فاتورة إلى',
  'Unit price': 'سعر الوحدة',
  'Discount': 'الخصم',
  'No items': 'لا توجد بنود',
  'TOTAL': 'الإجمالي',
  'TERMS & CONDITIONS': 'الشروط والأحكام',
  'Your Company': 'شركتك',
  'Valued Customer': 'عميلنا الكريم',
  'Phone': 'الهاتف',
  'Email': 'البريد الإلكتروني',
  'Page': 'صفحة',
  'Package': 'طرد',
  'TAX INVOICE': 'فاتورة ضريبية',
  'Subtotal:': 'الإجمالي الفرعي:',
  'Tax:': 'الضريبة:',
  'TOTAL:': 'الإجمالي:',
  'Purchase Order Details': 'تفاصيل أمر الشراء',
  'Supplier:': 'المورد:',
  'Instructions / Terms': 'التعليمات والشروط',
  'Ship To:': 'الشحن إلى:',
  'Notes:': 'ملاحظات:',
  'Authorized Signature (Electronic)': 'التوقيع المعتمد (إلكتروني)',
  'Add Stock Line': 'إضافة سطر مخزون',
  'Stock by Warehouse': 'المخزون حسب المستودع',
  'Total Quantity': 'إجمالي الكمية',
  'Create New Item': 'إنشاء صنف جديد',
  'Confirm Stock Movement': 'تأكيد حركة المخزون',
  'Save Item': 'حفظ الصنف',
  'Warehouse Stock & Lot Details': 'تفاصيل مخزون المستودعات والدفعات',
  'Price Range': 'نطاق السعر',
  'Stock Level': 'مستوى المخزون',
  'No address': 'لا يوجد عنوان',
  'No description': 'لا يوجد وصف',
  'No Expiry': 'بدون تاريخ صلاحية',
  'Edit Lot Definition': 'تعديل تعريف الدفعة',
  'New Lot Definition': 'تعريف دفعة جديد',
  'Edit Warehouse': 'تعديل المستودع',
  'New Warehouse': 'مستودع جديد',
  'Generic / Multiple': 'عام / متعدد',
  'Current Formulation': 'التركيبة الحالية',
  'Untitled Recipe': 'تركيبة بلا عنوان',
  'Item Name': 'اسم الصنف',
  'What would you like to import?': 'ما الذي ترغب في استيراده؟',
  'Select the type of items you want to bring into the system.': 'اختر نوع الأصناف التي تريد استيرادها إلى النظام.',
  'Import Products': 'استيراد المنتجات',
  'Import your physical goods and inventory items': 'استيراد السلع المادية وأصناف المخزون',
  'Import Services': 'استيراد الخدمات',
  'Import your professional services and non-inventory items': 'استيراد الخدمات المهنية والأصناف غير المخزنية',
  'Add New Employee': 'إضافة موظف جديد',
  'Create Employee': 'إنشاء موظف',
  'Update Employee': 'تحديث الموظف',
  'Add New Store': 'إضافة متجر جديد',
  'Edit Store': 'تعديل المتجر',
  'Create New User': 'إنشاء مستخدم جديد',
  'Edit User': 'تعديل المستخدم',
  'Update User': 'تحديث المستخدم',
  'New Organization': 'مؤسسة جديدة',
  'Save Organization': 'حفظ المؤسسة',
  'New Product/Service': 'منتج أو خدمة جديدة',
  'Save Product': 'حفظ المنتج',
  'Confirm & Generate': 'تأكيد وإنشاء',
  'Select All': 'تحديد الكل',
  'Deselect All': 'إلغاء تحديد الكل',
  'Full Access': 'صلاحية كاملة',
  'Activate': 'تفعيل',
  'Suspend': 'تعليق',
  'At least 8 characters': '8 أحرف على الأقل',
  'Leave blank to keep the current password': 'اتركه فارغًا للاحتفاظ بكلمة المرور الحالية',
  'Enter provider key, if required': 'أدخل مفتاح المزود إذا كان مطلوبًا',
  'Activate Organization': 'تفعيل المؤسسة',
  'Suspend Organization': 'تعليق المؤسسة',
  'Reminders': 'التذكيرات',
  'Repeating': 'التكرار',
  'Add All': 'إضافة الكل',
  'Date of Payment': 'تاريخ الدفع',
  'Deposit': 'إيداع',
  'Paid To (Account)': 'دُفع إلى (الحساب)',
  'Continue sale': 'متابعة عملية البيع',
  'Repeat this invoice every': 'تكرار هذه الفاتورة كل',
  'Status for generated invoices': 'حالة الفواتير المنشأة',
  'Insert placeholder': 'إدراج عنصر نائب',
  "Don't send reminders for amounts owing on an invoice under": 'عدم إرسال تذكيرات للمبالغ المستحقة الأقل من',
  'Email customers when an invoice is...': 'إرسال بريد للعملاء عندما تكون الفاتورة...',
  'Include a link to the invoice PDF': 'تضمين رابط لملف PDF الخاص بالفاتورة',
  'Include button to online invoice and detail summary': 'تضمين زر للفاتورة الإلكترونية وملخص التفاصيل',
  'Send if an invoice is': 'إرسال إذا كانت الفاتورة',
  'Send replies to': 'إرسال الردود إلى',
  'Confirm Deletion': 'تأكيد الحذف',
  'Are you sure you want to delete this quote? Its status will change to Deleted, and you can find it later using the Deleted filter.': 'هل أنت متأكد من حذف عرض السعر؟ ستتغير حالته إلى محذوف ويمكن العثور عليه لاحقًا باستخدام عامل تصفية المحذوف.',
  'NEWSLETTER': 'النشرة البريدية',
  'Information_': 'المعلومات_',
  'System_Status': 'حالة_النظام',
  'VERSION': 'الإصدار',
  'ALL ASSETS SECURED ON THE BLOCKCHAIN LEDGER. UNAUTHORIZED REPLICATION PROHIBITED.': 'جميع الأصول مؤمنة في سجل سلسلة الكتل. يُحظر النسخ غير المصرح به.',
  'The bloom cycle is temporary. All creations are protected by digital signature.': 'دورة الإزهار مؤقتة. جميع الإبداعات محمية بتوقيع رقمي.',
  'Account added successfully': 'تمت إضافة الحساب بنجاح',
  'Failed to load licenses': 'تعذر تحميل التراخيص',
  'Failed to load organizations': 'تعذر تحميل المؤسسات',
  'Failed to load products': 'تعذر تحميل المنتجات',
  'Failed to load users': 'تعذر تحميل المستخدمين',
  'Failed to parse CSV file': 'تعذر تحليل ملف CSV',
  'File uploaded successfully': 'تم رفع الملف بنجاح',
  'Shipped:': 'تم الشحن:',
  'found': 'تم العثور عليها',
  'Fetching': 'جاري التحميل',
  'reports': 'تقارير',
  'resources': 'موارد',
  'by:': 'بواسطة:',
  'Warehouses': 'المستودعات',
  'Categories': 'الفئات',
  'USD': 'دولار أمريكي',
  'Ready to start your day?': 'هل أنت مستعد لبدء يومك؟',
};

export const residualPatterns: Array<[RegExp, (...matches: string[]) => string]> = [
  [/^(\d+) (invoices|quotations|credit notes|bills|purchase orders) found$/i, (count, kind) => `تم العثور على ${count} ${kind === 'invoices' ? 'فاتورة' : kind === 'quotations' ? 'عرض سعر' : kind === 'credit notes' ? 'إشعار دائن' : kind === 'bills' ? 'فاتورة مشتريات' : 'أمر شراء'}`],
  [/^Fetching (invoices|quotations|credit notes|bills|purchase orders)\.\.\.$/i, kind => `جاري تحميل ${kind === 'invoices' ? 'الفواتير' : kind === 'quotations' ? 'عروض الأسعار' : kind === 'credit notes' ? 'الإشعارات الدائنة' : kind === 'bills' ? 'فواتير المشتريات' : 'أوامر الشراء'}...`],
  [/^No (invoices|quotations|credit notes|bills|purchase orders) found for this contact\.$/i, kind => `لا توجد ${kind === 'invoices' ? 'فواتير' : kind === 'quotations' ? 'عروض أسعار' : kind === 'credit notes' ? 'إشعارات دائنة' : kind === 'bills' ? 'فواتير مشتريات' : 'أوامر شراء'} لجهة الاتصال هذه.`],
  [/^(\d+) reports$/i, count => `${count} تقارير`],
  [/^(\d+) resources$/i, count => `${count} موارد`],
  [/^Update details for (.+)$/i, code => `تحديث تفاصيل ${code}`],
  [/^(Created|Restored|Updated|Deleted) by:$/i, action => `${action === 'Created' ? 'تم الإنشاء' : action === 'Restored' ? 'تمت الاستعادة' : action === 'Updated' ? 'تم التحديث' : 'تم الحذف'} بواسطة:`],
  [/^Receipt #(.*)$/i, number => `إيصال رقم ${number}`],
  [/^Date:\s*(.+)$/i, date => `التاريخ: ${date}`],
  [/^Items:$/i, () => 'البنود:'],
  [/^- (.+) \(Qty:\s*(.+)\)(.*)$/i, (item, quantity, rest) => `- ${item} (الكمية: ${quantity})${rest}`],
  [/^Subtotal:\s*(.+)$/i, amount => `الإجمالي الفرعي: ${amount}`],
  [/^Tax:\s*(.+)$/i, amount => `الضريبة: ${amount}`],
  [/^Total:\s*(.+)$/i, amount => `الإجمالي: ${amount}`],
  [/^Thank you for your business!$/i, () => 'شكرًا لتعاملكم معنا!'],
  [/^(.+) • Quote (.+)$/i, (organization, number) => `${organization} • عرض السعر ${number}`],
  [/^Contact:\s*(.+)$/i, contact => `جهة الاتصال: ${contact}`],
  [/^Type:\s*(.+)$/i, type => `النوع: ${type.toLowerCase() === 'activity' ? 'النشاط' : type.toLowerCase() === 'outstanding' ? 'المستحق' : translateEntityType(type)}`],
  [/^Delivery Date:\s*(.+)$/i, date => `تاريخ التسليم: ${date}`],
  [/^(.+) posted in:\s*(.+)$/i, (person, thread) => `${person === 'Someone' ? 'شخص ما' : person} نشر في: ${thread}`],
  [/^(.+) posted in a discussion on (.+)$/i, (person, document) => `${person === 'Someone' ? 'شخص ما' : person} نشر في مناقشة على ${document === 'document' ? 'المستند' : document}`],
  [/^(.+) mentioned you in:\s*(.+)$/i, (person, thread) => `${person === 'Someone' ? 'شخص ما' : person} أشار إليك في: ${thread}`],
  [/^A new task "(.+)" has been assigned to you\.$/i, task => `تم تعيين مهمة جديدة إليك: "${task}".`],
  [/^(.+) started a new thread:\s*"(.+)"$/i, (person, thread) => `${person === 'Someone' ? 'شخص ما' : person} بدأ مناقشة جديدة: "${thread}"`],
  [/^(.+) replied in a discussion thread\.$/i, person => `${person === 'Someone' ? 'شخص ما' : person} رد في مناقشة.`],
  [/^(.+) requested (\d+) more days for "(.+)"$/i, (person, days, task) => `${person} طلب ${days} أيام إضافية للمهمة "${task}"`],
  [/^Your extension request for "(.+)" was approved\. New due date:\s*(.+)$/i, (task, date) => `تمت الموافقة على طلب تمديد المهمة "${task}". تاريخ الاستحقاق الجديد: ${date}`],
  [/^(.+) mentioned you in a note on (.+)$/i, (person, entity) => `${person} أشار إليك في ملاحظة على ${translateEntityType(entity)}`],
  [/^Batch deposit of (\d+) payments recorded successfully$/i, count => `تم تسجيل إيداع مجمع لعدد ${count} من المدفوعات بنجاح`],
  [/^Successfully imported (\d+) (products|services|contacts)$/i, (count, type) => `تم استيراد ${count} ${type === 'products' ? 'منتج' : type === 'services' ? 'خدمة' : 'جهة اتصال'} بنجاح`],
  [/^Failed to reset license:\s*(.+)$/i, detail => `تعذرت إعادة ضبط الترخيص: ${detail}`],
  [/^Successfully processed (\d+) expense bills?!$/i, count => `تمت معالجة ${count} من فواتير المصروفات بنجاح!`],
  [/^Opened (\d+) quote email drafts?$/i, count => `تم فتح ${count} مسودة بريد لعروض الأسعار`],
  [/^(\d+) quotes? skipped because the contact email is missing$/i, count => `تم تخطي ${count} عرض سعر لعدم توفر بريد جهة الاتصال`],
  [/^(\d+) email drafts? blocked\. Allow pop-ups and try again\.$/i, count => `تم حظر ${count} مسودة بريد. اسمح بالنوافذ المنبثقة وحاول مجددًا.`],
  [/^(Star|Unstar) (.+)$/i, (action, report) => `${action.toLowerCase() === 'star' ? 'إضافة إلى المفضلة' : 'إزالة من المفضلة'}: ${report}`],
  [/^More actions for (.+)$/i, report => `مزيد من الإجراءات لـ ${report}`],
  [/^Analysis failed:\s*(.+)$/i, detail => `فشل التحليل: ${detail}`],
  [/^Period:\s*(.+)\s+to\s+(.+)$/i, (start, end) => `الفترة: من ${start} إلى ${end}`],
  [/^We found (\d+) transactions? in your file\. Review them before importing\.$/i, count => `عثرنا على ${count} معاملة في ملفك. راجعها قبل الاستيراد.`],
  [/^These transactions will be added to (.+)\. You can reconcile them in the next step\.$/i, account => `ستُضاف هذه المعاملات إلى ${account}. ويمكنك مطابقتها في الخطوة التالية.`],
  [/^Successfully imported (\d+) products\/services$/i, count => `تم استيراد ${count} من المنتجات والخدمات بنجاح`],
  [/^(.+) (.+) created successfully$/i, (type, number) => `تم إنشاء ${type} ${number} بنجاح`],
  [/^Less: Payment \((.+)\)$/i, amount => `ناقص: دفعة (${amount})`],
  [/^Are you sure you want to delete this (employee|payrun|task)\? This action cannot be undone\.$/i, entity => `هل أنت متأكد من حذف ${entity === 'employee' ? 'هذا الموظف' : entity === 'payrun' ? 'تشغيل الرواتب هذا' : 'هذه المهمة'}؟ لا يمكن التراجع عن هذا الإجراء.`],
  [/^For (.+)$/i, category => `لـ ${category}`],
  [/^By (.+) \((.+)\)$/i, (name, email) => `بواسطة ${name} (${email})`],
  [/^Quote (.+)$/i, number => `عرض السعر ${number}`],
  [/^Page (\d+)$/i, page => `صفحة ${page}`],
  [/^Phone:\s*(.+)$/i, phone => `الهاتف: ${phone}`],
  [/^Email:\s*(.+)$/i, email => `البريد الإلكتروني: ${email}`],
  [/^Receipt (.+)$/i, number => `إيصال ${number}`],
  [/^Order #(.*)$/i, number => `الطلب رقم ${number}`],
];
